/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Open_Mail_AppInputs */

const en_password_reset_open_mail_app = /** @type {(inputs: Password_Reset_Open_Mail_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open mail app`)
};

const es_password_reset_open_mail_app = /** @type {(inputs: Password_Reset_Open_Mail_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir la app de correo`)
};

/**
* | output |
* | --- |
* | "Open mail app" |
*
* @param {Password_Reset_Open_Mail_AppInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_open_mail_app = /** @type {((inputs?: Password_Reset_Open_Mail_AppInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Open_Mail_AppInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_open_mail_app(inputs)
	return en_password_reset_open_mail_app(inputs)
});